import { makeTransitionComponent } from './makeTransitionComponent';

export const TransitionSlideUp = makeTransitionComponent((timeout) => ({
    default: {
        opacity: 0,
        transform: 'translateY(100%)',
        transitionDelay: '0ms',
        transitionDuration: `${timeout}ms`,
        transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
        transitionProperty: 'transform, opacity',
    },
    entering: { transform: 'translateY(100%)', opacity: 0 },
    entered: { transform: 'translateY(0)', opacity: 1 },
}));
